var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.968
    },
    fill: "#672f2a",
    d: "M 184.5,8.5 C 261.261,5.29866 321.427,34.9653 365,97.5C 395.616,147.815 403.283,201.482 388,258.5C 382.065,279.535 372.565,298.702 359.5,316C 369.333,325.833 379.167,335.667 389,345.5C 398.102,341.176 406.935,341.676 415.5,347C 440.886,372.93 466.386,398.763 492,424.5C 503.898,443.359 504.565,462.692 494,482.5C 481.9,498.763 465.733,505.263 445.5,502C 436.477,500.487 428.477,496.821 421.5,491C 396.305,466.139 371.472,440.972 347,415.5C 345.139,413.112 343.806,410.446 343,407.5C 342.484,401.782 342.484,396.115 343,390.5C 333.333,380.833 323.667,371.167 314,361.5C 268.132,393.475 217.632,403.975 162.5,393C 88.1782,374.345 39.3449,328.512 16,255.5C -2.8395,176.996 16.9938,110.163 75.5,55C 107.131,28.5187 143.465,13.0187 184.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#525e6f",
    d: "M 179.5,19.5 C 244.873,14.4567 299.373,36.1233 343,84.5C 388.507,143.048 397.841,207.048 371,276.5C 365.681,288.479 359.347,299.813 352,310.5C 337.446,325.054 322.946,339.554 308.5,354C 262.453,384.51 212.453,393.51 158.5,381C 97.9318,363.096 55.7651,324.929 32,266.5C 6.80666,187.772 23.9733,119.938 83.5,63C 111.432,39.5342 143.432,25.0342 179.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#68312c",
    d: "M 184.5,63.5 C 245.402,59.5321 291.902,83.1988 324,134.5C 344.986,174.545 346.986,215.545 330,257.5C 308.546,302.935 273.046,330.435 223.5,340C 164.848,346.418 118.681,325.584 85,277.5C 60.5545,235.949 56.8879,192.616 74,147.5C 96.3052,100.358 133.139,72.3584 184.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3e2e2",
    d: "M 185.5,73.5 C 242.015,70.005 285.182,92.005 315,139.5C 340.073,189.113 336.407,236.447 304,281.5C 267.98,323.618 222.814,338.784 168.5,327C 115.198,309.362 83.6985,272.862 74,217.5C 70.1719,160.984 92.3385,118.151 140.5,89C 154.757,81.3043 169.757,76.1376 185.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#69322d",
    d: "M 258.5,111.5 C 276.798,110.295 284.965,118.628 283,136.5C 278.221,147.14 270.054,151.307 258.5,149C 255.827,147.999 253.493,146.499 251.5,144.5C 246.833,147.5 242.167,150.5 237.5,153.5C 238.333,163.183 235,171.016 227.5,177C 212.017,182.256 202.017,176.923 197.5,161C 194.312,160.245 191.145,159.411 188,158.5C 178.845,169.997 168.512,171.331 157,162.5C 152.086,165.04 147.253,167.706 142.5,170.5C 142.759,189.081 133.759,197.247 115.5,195C 102.513,187.056 100.013,176.556 108,163.5C 117.04,155.867 126.373,155.534 136,162.5C 140.696,159.649 145.53,156.983 150.5,154.5C 149.839,140.456 156.339,132.123 170,129.5C 181.669,130.67 188.169,137.004 189.5,148.5C 193.499,149.338 197.499,149.838 201.5,150C 205.287,144.685 210.454,141.518 217,140.5C 222.427,141.649 227.594,143.149 232.5,145C 236.667,142.167 240.833,139.333 245,136.5C 244.144,125.208 248.644,116.875 258.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#606a76",
    d: "M 62.5,112.5 C 68.1778,112.157 70.3445,114.824 69,120.5C 66,125.833 63,131.167 60,136.5C 53.8318,138.99 51.1651,136.99 52,130.5C 54.7697,123.944 58.2697,117.944 62.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6eacf8",
    d: "M 260.5,121.5 C 270.659,120.158 274.826,124.491 273,134.5C 270.103,139.155 265.937,140.655 260.5,139C 253.864,133.091 253.864,127.258 260.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6eaaf6",
    d: "M 167.5,139.5 C 176.478,139.31 180.311,143.643 179,152.5C 176.647,157.426 172.814,159.26 167.5,158C 162.268,155.367 160.435,151.201 162,145.5C 163.36,142.977 165.193,140.977 167.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6eacf9",
    d: "M 213.5,151.5 C 223.659,150.158 227.826,154.491 226,164.5C 219.833,171.412 214.167,171.079 209,163.5C 207.474,158.239 208.974,154.239 213.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b312d",
    d: "M 247.5,160.5 C 259.171,160.333 270.838,160.5 282.5,161C 283.667,161.5 284.5,162.333 285,163.5C 285.667,197.167 285.667,230.833 285,264.5C 284.5,265.667 283.667,266.5 282.5,267C 270.833,267.667 259.167,267.667 247.5,267C 247,266.5 246.5,266 246,265.5C 245.333,231.167 245.333,196.833 246,162.5C 246.717,161.956 247.217,161.289 247.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#606a76",
    d: "M 42.5,164.5 C 47.1734,163.98 49.5068,165.98 49.5,170.5C 41.314,214.74 49.814,255.407 75,292.5C 74.8678,299.296 71.8678,300.963 66,297.5C 39.0321,257.903 30.3654,214.57 40,167.5C 40.6979,166.309 41.5313,165.309 42.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6eacf9",
    d: "M 118.5,167.5 C 127.544,166.713 131.71,170.713 131,179.5C 128.598,185.092 124.431,186.925 118.5,185C 113.845,182.103 112.345,177.937 114,172.5C 115.366,170.638 116.866,168.972 118.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f94967",
    d: "M 255.5,170.5 C 261.833,170.5 268.167,170.5 274.5,170.5C 274.5,199.5 274.5,228.5 274.5,257.5C 268.167,257.5 261.833,257.5 255.5,257.5C 255.5,228.5 255.5,199.5 255.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#682f2a",
    d: "M 152.5,179.5 C 163.838,179.333 175.172,179.5 186.5,180C 187.416,180.374 188.25,180.874 189,181.5C 189.667,209.5 189.667,237.5 189,265.5C 188.5,266 188,266.5 187.5,267C 175.833,267.667 164.167,267.667 152.5,267C 152,266.5 151.5,266 151,265.5C 150.333,237.5 150.333,209.5 151,181.5C 151.717,180.956 152.217,180.289 152.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a522c",
    d: "M 179.5,257.5 C 179.5,235.167 179.5,212.833 179.5,190.5C 173.167,190.5 166.833,190.5 160.5,190.5C 160.5,212.833 160.5,235.167 160.5,257.5C 159.503,235.006 159.169,212.339 159.5,189.5C 166.5,189.5 173.5,189.5 180.5,189.5C 180.831,212.339 180.497,235.006 179.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aab733",
    d: "M 179.5,257.5 C 173.167,257.5 166.833,257.5 160.5,257.5C 160.5,235.167 160.5,212.833 160.5,190.5C 166.833,190.5 173.167,190.5 179.5,190.5C 179.5,212.833 179.5,235.167 179.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c332d",
    d: "M 200.5,197.5 C 212.171,197.333 223.838,197.5 235.5,198C 236.308,198.308 236.975,198.808 237.5,199.5C 238.655,221.124 238.822,242.79 238,264.5C 237.167,265.333 236.333,266.167 235.5,267C 223.833,267.667 212.167,267.667 200.5,267C 200,266.5 199.5,266 199,265.5C 198.333,243.5 198.333,221.5 199,199.5C 199.717,198.956 200.217,198.289 200.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feb95b",
    d: "M 208.5,207.5 C 214.833,207.5 221.167,207.5 227.5,207.5C 227.5,224.167 227.5,240.833 227.5,257.5C 221.167,257.5 214.833,257.5 208.5,257.5C 208.5,240.833 208.5,224.167 208.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b322d",
    d: "M 105.5,209.5 C 117.171,209.333 128.838,209.5 140.5,210C 141,210.5 141.5,211 142,211.5C 142.667,229.5 142.667,247.5 142,265.5C 141.5,266 141,266.5 140.5,267C 128.833,267.667 117.167,267.667 105.5,267C 104.667,266.167 103.833,265.333 103,264.5C 102.333,247.167 102.333,229.833 103,212.5C 104.045,211.627 104.878,210.627 105.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe8b82",
    d: "M 113.5,219.5 C 119.833,219.5 126.167,219.5 132.5,219.5C 132.5,232.167 132.5,244.833 132.5,257.5C 126.167,257.5 119.833,257.5 113.5,257.5C 113.5,244.833 113.5,232.167 113.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#424f5f",
    d: "M 351.5,322.5 C 361.913,331.409 371.913,340.909 381.5,351C 371.029,360.47 360.863,370.303 351,380.5C 341.652,371.319 332.486,361.986 323.5,352.5C 332.516,342.152 341.85,332.152 351.5,322.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#525e6f",
    d: "M 397.5,352.5 C 401.966,352.156 405.966,353.323 409.5,356C 435,382.167 460.5,408.333 486,434.5C 496.533,455.214 492.7,472.714 474.5,487C 460.833,495.667 447.167,495.667 433.5,487C 407.387,460.887 381.221,434.721 355,408.5C 351.591,402.948 351.924,397.615 356,392.5C 369.449,378.547 383.283,365.213 397.5,352.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#606a76",
    d: "M 416.5,397.5 C 418.199,397.34 419.866,397.506 421.5,398C 430.333,406.833 439.167,415.667 448,424.5C 448.944,430.553 446.444,432.72 440.5,431C 431.667,422.167 422.833,413.333 414,404.5C 413.333,403.167 413.333,401.833 414,400.5C 415.045,399.627 415.878,398.627 416.5,397.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.225d9518e202ce2a2564f319119f2ed2.svg";
export { ForwardRef as ReactComponent };